export const TOGGLE_EDIT_DIALOG = 'TOGGLE_EDIT_DIALOG';
export const UPDATE_CARD = 'UPDATE_CARD';
export const TOGGLE_DELETE_PROJECT_DIALOG = 'TOGGLE_DELETE_PROJECT_DIALOG';
export const TOGGLE_RELEASE_FLYOUT = 'TOGGLE_RELEASE_FLYOUT';
export const TOGGLE_EDIT_MODE = 'TOGGLE_EDIT_MODE';
export const TOGGLE_GOAL = 'TOGGLE_GOAL';
export const RESET_STORYMAP = 'RESET_STORYMAP';
export const TOGGLE_SHOW_CLOSED = 'TOGGLE_SHOW_CLOSED';
export const TOGGLE_EDIT_PROJECT_DIALOG = 'TOGGLE_EDIT_PROJECT_DIALOG';